import { PUSH_NOTIFICATION_SUBSCRIBE } from './types';

/**
 * Attempt to subscribe to push notification.
 *
 * @return {Object}
 */
export function subscribePushNotification() {
  return {
    type: PUSH_NOTIFICATION_SUBSCRIBE,
  };
}
